module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-kyoto-3-7e4b7516a98f3510907a406ab735562c.webp";